import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
const eTicketEndpoints = {
    get: 'api/eticket/get',
    feedback: 'api/eticket/feedback',
    voting: 'api/eticket/voting',
};
class EticketAPI {
    constructor() {
        this.getTicketInformation = (defaultRequestParams, servicesApi, customerUUID, saleId, ext_id) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${eTicketEndpoints.get}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId,
                    ext_id }),
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.voting = (defaultRequestParams, servicesApi, customerUUID, saleId, ratingType, rating, departmentId, ext_id) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${eTicketEndpoints.voting}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId,
                    rating,
                    ratingType,
                    departmentId,
                    ext_id }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.sendFeedback = (defaultRequestParams, servicesApi, customerUUID, saleId, feedback, ext_id) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${eTicketEndpoints.feedback}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId,
                    ext_id }),
                data: feedback,
                headers: {
                    'Content-Type': 'text/plain',
                },
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new EticketAPI();
